'use client';

import React from 'react';
import { Notification } from '@/components';
import { useStoreNotifications } from '@/store';
import { STATUS_MESSAGES } from '@/constants/labels';
import { FEATURE_FLAGS } from '@/constants';

const Notifications = () => {
  const maxVisible = 5;
  const showUnreadOnly = false;
  const { notifications, markNotificationRead, removeNotification } = useStoreNotifications();

  const visibleNotifications = notifications
    .filter((notification) => (showUnreadOnly ? !notification.isRead : true))
    .slice(0, Math.max(0, maxVisible));

  const handleClose = (notificationId: string) => {
    markNotificationRead(notificationId);
    removeNotification(notificationId);
  };

  // Don't render the notifications component if the feature flag is disabled
  if (!FEATURE_FLAGS.ENABLE_APP_NOTIFICATIONS) {
    return null;
  }

  return (
    <div className="absolute right-0 top-0 z-50 p-2" role="region" aria-live="polite">
      <div className="flex flex-col gap-4">
        {visibleNotifications.length === 0 ? (
          <p className="text-sm text-neutral-gray-600">{STATUS_MESSAGES.NO_NOTIFICATIONS}</p>
        ) : (
          visibleNotifications.map((notification) => (
            <Notification
              key={notification.id}
              message={notification.message}
              variant={notification.variant}
              onClose={() => handleClose(notification.id)}
            />
          ))
        )}
      </div>
    </div>
  );
};

Notifications.displayName = 'Notifications';

export default Notifications;
